
jQuery(document).foundation();
jQuery(document).ready(setTimeout(
    function() {
        window.dispatchEvent(new Event('resize'));
    }, 1000));

